/* ++++++++ START: Services used to switch between data bases, these should not go to PRODUCTION or final customer ++++++++ */

/**
 * Switches the active database connection to the one specified by the parameter.
 *
 * @param {string} name - The name of the target database to switch to.
 * @returns {Object} An object containing a confirmation message.
 * @example
 * // Returns:
 * // { "message": "Successfully switched to HOSPITALS database." }
 */

export const serviceSwitchDataBase = async (choice) => {
  const ENDPOINT = `/api/set_db?db_choice=${choice}`;
  try {
    const response = await fetch(ENDPOINT, {
      method: "POST"
    });

    if (!response.ok) {
      throw new Error("DB switch failed");
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    throw new Error(error);
  }
};


/**
 * Returns the status of data base
 * @returns "ok"
 */
export const getStatus = async () => {
  const ENDPOINT = `/api/status`;
  const response = await fetch(ENDPOINT);
  if (!response.ok) {
    throw new Error("Failed to fetch status data");
  }

  const data = await response.json();
  return data;
};

/* ++++++++ END: Services used to switch between data bases, these should not go to PRODUCTION or final customer ++++++++ */